
var accountServiceObj =
{
    register(userRegistration) {
        return axios.post("/api/account", userRegistration);
    },
    activateAccount(accountActivation) {
        return axios.post("/api/account/ActivateAccount", accountActivation);
    },
    // getPasswordResetToken(userId) {
    //     return axios.get("/api/account/GetPasswordResetToken/" + userId);
    // },
    resetPassword(passReset) {
        return axios.post("/api/account/ResetPassword", passReset);
    },
    forgotPassword(emailAddress) {
        return axios.post("/api/account/ForgotPassword/" + emailAddress);
    },
}

export const accountService = accountServiceObj;
